export default {
    namespaced: true,
    state: {
        tokenAuth: false,
        username: '',
        store: [],
        perfil: '',
        options: [],
        idProvider:0,
        name:'',
        token:""
    },
    mutations: {
        setAuthToken(state, val) {
            state.tokenAuth = val.status;
            state.username = val.username;
            state.store = val.store;
            state.perfil = val.perfil;
            state.options = val.options;
            state.idProvider=val.idProvider;
            state.name=val.name
        },
        setToken(state,token){
            state.token = token;
        }
    },
    getters: {
        isAuthenticated(state) {
            return state.tokenAuth;
        },
        optionsMenu(state) {
            return state.options;
        },
        profile(state) {
            return state.perfil;
        },
        token(state) {
            return state.token;
        }
        
    }
}